import { determineLockdownDownloadLinkType } from "@verity/components";
import apiClient from "./api-client";

export async function getLockdownDownloadUrl() {
	const platform = await determineLockdownDownloadLinkType();
	if (platform) {
		return apiClient.download.getLockdownDownloadUrl(platform);
	} else {
		return undefined;
	}
}

export function triggerFileDownload(file: Blob | File, fileName: string) {
	const url = URL.createObjectURL(file);
	const link = document.createElement("a");
	link.href = url;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
}
